/**
 * ChatIconButton - Navbar icon with unread badge
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useChat } from '../context/ChatProvider';

export const ChatIconButton: React.FC = () => {
  const navigate = useNavigate();
  const { unreadTotal } = useChat();

  return (
    <button
      onClick={() => navigate('/chat')}
      className="relative p-2 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-500"
      aria-label="View messages"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        />
      </svg>
      {unreadTotal > 0 && (
        <span
          className="absolute top-1 right-1 block h-2.5 w-2.5 transform -translate-y-1/2 translate-x-1/2 rounded-full text-red-500 ring-2 ring-white bg-red-500"
          aria-label={`${unreadTotal} unread messages`}
        ></span>
      )}
    </button>
  );
};

